import { Title } from '../../utils/title';
import Layout from './Layout';
import styles from './Privacy.module.scss';

const Privacy = () => {
  return (
    <Layout>
      <div className={styles.root}>

        <Title value='Privacy Policy' />

        {
          /*
           * BEGIN HTML
           */
        }
        <div className="d-flex justify-content-center align-items-center">
          <h1 className="card-title text-muted text-black">PRIVACY POLICY</h1>
        </div>
        <p className="card-text"></p>
        We at Chimeable (“Company” or “We” or “Us” or “Our”) respect your privacy and are
        committed to protecting it through Our compliance with this Privacy Policy (“Policy”).
        <p className="card-text">
          This Policy describes the types of information We may collect from you or that you may
          provide when you access or use Our website, mobile application, or any other service We
          provide (collectively, “Services”). This Policy also describes Our practices for
          collecting, using, maintaining, protecting, and disclosing that information.
        </p>
        <p className="card-text">
          Please read this Policy carefully before using Our Services. By using Our Services, you
          accept and agree to be bound by this Policy, which may be revised from time to time. If
          you do not agree to this Policy, you may not access or use Our Services.
        </p>
        <h2 className="card-subtitle mb-2 text-muted text-black">Information We Collect</h2>
        <p className="card-text font-weight-bold">
          We may collect several types of information from and about you, including:
          <ul>
            <li>
              Personal Information. This may include your name, username, email address, phone
              number, gender, address, profile photos, date of birth, interests, social media
              platform (including but not limited to Twitter, TikTok, Youtube, Google, Facebook,
              Instagram ) usernames and information shared by these platforms through connection
              of these social platforms with our services, and other personal details.
            </li>
            <li>
              Content: This includes reviews, comments, photos, videos, and other materials that
              you upload or share on our platform.
            </li>
            <li>
              Usage Information. This may include information about your use of Our Services, such
              as pages visited, browser information, time spent on pages, features used, and other
              similar information.
            </li>
            <li>
              Location Information. We may collect information about your location when you access
              or use Our Services, including IP address, and other similar information.
            </li>
            <li>
              Cookies and Other Technologies. We may use cookies, web beacons, and other similar
              technologies to collect information about your use of Our Services.
            </li>
          </ul>
        </p>
        <h2 className="card-subtitle mb-2 text-muted text-black">How We Use Your Information</h2>
        <p className="card-text">
          We use your information for the following purposes:
          <ul>
            <li>
              To provide and improve our platform: We use your information to operate our
              platform, personalize your experience, and improve our features and services. We may
              also use your informtion to measure performances of our Services.
            </li>
            <li>
              To communicate with you: We use your contact information to send you updates about
              our platform, respond to your inquiries, and provide customer support.
            </li>
            <li>
              To comply with legal obligations: We may use your information to comply with legal
              obligations, such as responding to court orders or government requests.
            </li>
          </ul>
        </p>
        <h2 className="card-subtitle mb-2 text-muted text-black">
          How We Share Your Information
        </h2>
        <p className="card-text">
          We may share your information with the following parties:
          <ul>
            <li>
              Third-party service providers: We may share your information with third-party
              service providers who help us operate our platform, such as hosting providers,
              platform and Services performance measurement services, shipment and shipment
              related service providers, payment processors, and marketing / advertisement
              agencies.
            </li>
            <li>
              Partners: We may share your information (including some personal infomation) and
              content with our partners. These partners may publish this infomation (including
              some personal infomation) and content on their publically accessible website, mobile
              app and other platforms.
            </li>
            <li>
              Law enforcement or government agencies: We may share your information with law
              enforcement or government agencies to comply with legal obligations or investigate
              potential crimes.
            </li>
          </ul>
        </p>
        <h2 className="card-subtitle mb-2 text-muted text-black">Your Choices and Rights</h2>
        <p className="card-text">
          You have the following choices and rights regarding your information:
          <ul>
            <li>
              Access and update your information: You can access and update your information
              through your account settings.
            </li>
            <li>
              Control your privacy settings: You can opt-out of sharing your data with
              third-parties and partners by visiting your account's "Settings" page.
            </li>
            <li>
              Request deletion of your information: You can request that we delete your
              information by contacting us at privacy@chimeable.com.
            </li>
          </ul>
        </p>
        <h2 className="card-subtitle mb-2 text-muted text-black">Security of Your Information</h2>
        <p className="card-text">
          We take appropriate measures to protect your information from unauthorized access,
          disclosure, or misuse. However, no security measures are perfect, and we cannot
          guarantee the security of your information.
        </p>
        <h2 className="card-subtitle mb-2 text-muted text-black">How we use cookies</h2>
        <p className="card-text">
          A cookie is a small file which asks permission to be placed on your computer's hard
          drive. Once you agree, the file is added and the cookie helps analyze web traffic or
          lets you know when you visit a particular site. Cookies allow web applications to
          respond to you as an individual. The web application can tailor its operations to your
          needs, likes, and dislikes by gathering and remembering information about your
          preferences.
        </p>
        <p className="card-text">
          Overall, cookies help us provide you with a better website by enabling us to monitor
          which pages you find useful and which you do not. A cookie in no way gives us access to
          your computer or any information about you, other than the data you choose to share with
          us. You can choose to accept or decline cookies. Most web browsers automatically accept
          cookies, but you can usually modify your browser setting to decline cookies if you
          prefer. This may prevent you from taking full advantage of the website.
        </p>
        <p className="card-text">
          You can get more information on cookies and how to manage them in our cookie policy
          https://www.chimeable.com/cookie-policy.
        </p>
        <h2 className="card-subtitle mb-2 text-muted text-black">
          Third party websites/platforms
        </h2>
        <p className="card-text">
          Our website may contain links to other websites/platforms of interest. However, once you
          have used these links to leave our site, you should note that we do not have any control
          over that other website. Therefore, we cannot be responsible for the protection and
          privacy of any information which you provide whilst visiting such sites and such sites
          are not governed by this privacy statement. You should exercise caution and look at the
          privacy statement applicable to the website in question.
        </p>
        <h2 className="card-subtitle mb-2 text-muted text-black">Children's Privacy</h2>
        <p className="card-text">
          Our platform is not intended for children under the age of 18. We do not knowingly
          collect personal information from children under 18. If you are a parent or guardian and
          believe that your child has provided us with personal information, please contact us at
          privacy@chimeable.com.
        </p>
        <h2 className="card-subtitle mb-2 text-muted text-black">Do Not Track signals</h2>
        <p className="card-text">
          It's important to keep in mind that your browser preferences might enable the automatic
          transmission of a "Do Not Track" signal to the websites and online services you access.
          However, similar to other websites and online services, we do not make any changes to
          our practices in response to receiving a "Do Not Track" signal from a visitor's browser.
          For further information about "Do Not Track," you may want to check out
          www.allaboutdnt.com.
        </p>
        <h2 className="card-subtitle mb-2 text-muted text-black">
          Changes to this Privacy Policy
        </h2>
        <p className="card-text">
          We may update this privacy policy from time to time. We will notify you of any material
          changes by posting the updated policy on our platform or sending you a notification.
        </p>
        <h2 className="card-subtitle mb-2 text-muted text-black">Contact Us</h2>
        <p>
          If you have any questions or concerns about this privacy policy or our platform, please
          contact us at privacy@chimeable.com.
        </p>
        <div className="d-flex justify-content-center align-items-center">
          <p> Copyright © 2025. Chimeable Inc.</p>
        </div>
        <div className="d-flex justify-content-center align-items-center">
          <p> All Rights Reserved.</p>
        </div>
        <div className="d-flex justify-content-center align-items-center">
          <p> Last updated: March 13, 2023</p>
        </div>
        {
          /*
           * END HTML
           */
        }

      </div>
    </Layout>
  );
};

export default Privacy;